// extracted by mini-css-extract-plugin
module.exports = {"dateWrapper":"_a85fdf5"};